export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_team_unassigned_manage', // FORK: custom role team permission normalization
  'conversation_participating_manage',
  'inbox_view_manage', // FORK: custom role inbox view permission
  'inbox_manage', // FORK: custom role inbox manage permission
  'conversation_reply_assigned_only', // FORK: custom role reply assigned only
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_team_unassigned_manage', // FORK: custom role team permission normalization
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS =
  'conversation_team_unassigned_manage'; // FORK: custom role team permission normalization

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const INBOX_VIEW_PERMISSIONS = 'inbox_view_manage'; // FORK: custom role inbox view permission

export const INBOX_MANAGE_PERMISSIONS = 'inbox_manage'; // FORK: custom role inbox manage permission

// FORK: custom role reply assigned only — opt-in restriction (present = restrict)
export const REPLY_ASSIGNED_ONLY_PERMISSION =
  'conversation_reply_assigned_only';

// FORK: custom role inbox view permission — shared route/menu gate
export const INBOX_VIEW_ROUTE_PERMISSIONS = [...ROLES, INBOX_VIEW_PERMISSIONS];

// FORK: custom role inbox manage permission — settings list/show, not create/delete
export const INBOX_MANAGE_ROUTE_PERMISSIONS = [
  'administrator',
  INBOX_MANAGE_PERMISSIONS,
];

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS, // FORK: custom role team permission normalization
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
